import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const ErrorFooterContainer = styled.div(({ theme }) => ({
    paddingTop: theme.spacing.xSmall,
}));

export const ErrorFooterHeadingWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing.xxSmall,
    paddingBottom: theme.spacing.medium,
}));

export const ErrorFooterSubtextHeading = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_High_Emphasis,
}));

export const ErrorFooterSubtextSubtext = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
}));
